declare var google: any;
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Loader } from '@googlemaps/js-api-loader';
import { environment } from '../../environments/environment';
import { AddressComponent } from './models/AddressComponent';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {
  mapLoader: Loader;

  constructor(private http$: HttpClient) {
    this.mapLoader = new Loader({
      apiKey: environment.googleMapsApiKey,
      version: 'weekly',
      libraries: ['places', 'core', 'geometry', 'maps', 'marker'],
      region: 'NZ'
    });
  }

  getLoader() {
    return this.mapLoader;
  }

  searchGoogleAddresses(term: string) {
    return new Observable<any[]>(observer => {
      this.mapLoader.importLibrary('places').then(
        ({ AutocompleteService }: any) => {
          const service = new AutocompleteService();
          service.getPlacePredictions(
            {
              input: term,
              componentRestrictions: {
                country: 'nz'
              },
            }, (results: any[], status: any) => {
              observer.next(results);
              observer.complete();
            }
          );
        }
      );
    });
  }

  getGoogleAddressDetailsByLatLng(lat: number, lng: number) {
    return this.mapLoader.importLibrary('geocoding').then(
      ({ Geocoder, GeocoderStatus }: any) => {
        const service = new Geocoder();
        return service.geocode({
          'location': { lat, lng }
        }, ({ results, status }: any) => {
          if (status === GeocoderStatus.OK) {
            return results[0];
          } else {
            return null;
          }
        });
      }
    );
  }

  getAddressLineFromAddressComponents(addressComponents: AddressComponent[]) {
    let addressLine = '';
    addressComponents.forEach((component: AddressComponent) => {
      if (component.types.includes('street_number')) {
        addressLine += component.longName || component.long_name + ' ';
      }
      if (component.types.includes('route')) {
        addressLine += component.longName || component.long_name + ', ';
      }
      if (component.types.includes('locality')) {
        addressLine += component.longName || component.long_name + ', ';
      }
      if (component.types.includes('administrative_area_level_1')) {
        addressLine += component.longName || component.long_name + ', ';
      }
      if (component.types.includes('country')) {
        addressLine += component.longName || component.long_name;
      }
      if (component.types.includes('postal_code')) {
        addressLine += ' ' + (component.longName || component.long_name);
      }
    });
    return addressLine;
  }

  async checkGoogleAddressPlaceId(placeId: string): Promise<boolean> {
    return this.mapLoader.importLibrary('geocoding').then(
      ({ Geocoder, GeocoderStatus }: any) => {
        const service = new Geocoder();
        return new Promise((resolve) => {
          service.geocode({
            'placeId': placeId
          }, (result: any, status: any) => {
            if (status === GeocoderStatus.OK && result) {
              resolve(true);
            } else {
              resolve(false);
            }
          });
        });
      }
    );
  }

  async getGoogleAddressDetails(placeId: string) {
    return this.mapLoader.importLibrary('geocoding').then(
      ({ Geocoder, GeocoderStatus }: any) => {
        const service = new Geocoder();
        return service.geocode({
          'placeId': placeId
        }, (response: any) => {
          if (response === null || response === undefined) {
            return null;
          }
          const { results, status } = response;
          if (status === GeocoderStatus.OK) {

            let result = {
              addressComponents: results[0].address_components,
              lat: results[0].geometry.location.lat(),
              lng: results[0].geometry.location.lng()
            };
            return result;
          } else {
            return null;
          }
        });
      }
    );
  }
}
